import { formatCurrencyAmount } from 'lib';
import { useTranslation } from 'react-i18next';

const CARD_CLASS = 'bg-white border border-[#e5e7eb] rounded-xl p-6 h-[390px] flex flex-col';

function formatAmount(value, currency) {
  if (value == null) return '-';
  const normalized = Number.isInteger(value) ? value : value.toFixed(2);
  return formatCurrencyAmount(normalized, currency);
}

const MrrSummaryCard = ({ data }) => {
  const { t } = useTranslation();
  const currencies = data?.currencies || [];

  if (!currencies.length) {
    return (
      <div className={CARD_CLASS}>
        <p className="text-[15px] font-semibold text-[#353E4A] mb-5">
          {t('subscriptions.admin.overview.mrr.title')}
        </p>
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <p className="text-[13px] text-[#97A3B5]">
            {t('subscriptions.admin.overview.mrr.empty')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={CARD_CLASS}>
      <p className="text-[15px] font-semibold text-[#353E4A] mb-5">
        {t('subscriptions.admin.overview.mrr.title')}
      </p>
      <div className="min-h-0 flex-1 overflow-y-auto pr-1 space-y-3">
        {currencies.map((currencyBlock) => (
          <div key={currencyBlock.currency} className="rounded-lg border border-[#e6edf5] p-3">
            <div className="flex items-center justify-between">
              <p className="text-[12px] font-semibold uppercase tracking-wide text-[#334155]">
                {currencyBlock.currency}
              </p>
              <p className="text-[13px] font-semibold text-[#334155]">
                {formatAmount(currencyBlock.total, currencyBlock.currency)}
              </p>
            </div>
            <p className="text-[11px] text-gray-600 mt-1">
              {t('subscriptions.admin.overview.mrr.monthlyPlans')}: {' '}
              {formatAmount(currencyBlock.byInterval?.monthly?.total || 0, currencyBlock.currency)}
            </p>
            <p className="text-[11px] text-gray-600">
              {t('subscriptions.admin.overview.mrr.yearlyPlans')}: {' '}
              {formatAmount(currencyBlock.byInterval?.yearly?.total || 0, currencyBlock.currency)}
            </p>
            <p className="text-[11px] text-gray-600">
              {currencyBlock.subscribers} {t('subscriptions.admin.overview.total')}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MrrSummaryCard;
